
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { JielongGoodsItem, JielongGoodsTag } from "@/api/jielong";
import ShareMessageToWeixin from "@/components/ShareMessageToWeixin/index.vue";

@Component({ components: { ShareMessageToWeixin } })
export default class PreviewGoodsItem extends Vue {
  @Prop({ required: true }) item!: JielongGoodsItem;
  @Prop({ type: Boolean, default: false }) isDetailMode!: boolean;

  @Getter logoUrl!: string;

  get displayTags (): JielongGoodsTag[] {
    return [...(this.item.tagList || [])].sort((a, b) => (a.sortNo || 0) - (b.sortNo || 0));
  }

  get showMetaRow (): boolean {
    return this.displayTags.length > 0 || this.isDetailMode;
  }

  get imageSrc (): string {
    return this.item.goodsImage ? ((this.$store.state.user.sftpUrl || "") + this.item.goodsImage) : ''
  }

  get stockLabel (): string {
    if (this.item.stockQty === null || this.item.stockQty === undefined) {
      return "库存不限";
    }
    const remain = this.item.stockQty - (this.item.soldQty || 0);
    return remain > 0 ? `剩余${remain}` : "库存不足";
  }

  get showOriginalPrice (): boolean {
    const original = this.item.originalPrice;
    const join = this.item.joinPrice;
    return original != null && join != null && original > join;
  }

  get joinPriceParts (): { integer: string; decimal: string } {
    const text = this.formatPrice(this.item.joinPrice);
    if (text === "--") {
      return { integer: "--", decimal: "" };
    }
    const dotIndex = text.indexOf(".");
    if (dotIndex < 0) {
      return { integer: text, decimal: "" };
    }
    return {
      integer: text.slice(0, dotIndex),
      decimal: text.slice(dotIndex),
    };
  }

  get priceText (): string {
    const price = this.formatPrice(this.item.joinPrice);
    if (price === "--") return price;
    return this.item.sellUnitWay ? `${price}/${this.item.sellUnitWay}` : price;
  }

  onShare (): void {
    const images = this.imageSrc ? [this.imageSrc] : [];
    (this.$refs.ShareMessageToWeixinRef as any).showPopup({
      type: "product",
      joinActivityId: this.item.joinActivityId,
      goodsId: this.item.goodsId,
      title: this.item.saleTitle || "（未填写商品名称）",
      createTime: this.item.createTime,
      arrivalTime: this.item.arrivalTime,
      images,
      price: this.item.joinPrice,
      unit: `${this.item.joinSellUnit == 1 ? '' : this.item.joinSellUnit}${this.item.sellUnitWay}`,
      linePrice: this.item.originalPrice,
      storeName: this.$store.state.user.info.storeName || "",
      storeLogo: this.logoUrl,
    });
  }

  formatPrice (val: number | null | undefined): string {
    if (val === null || val === undefined) return "--";
    const n = Number(val);
    if (Number.isNaN(n)) return "--";
    return n % 1 === 0 ? String(n) : n.toFixed(2);
  }
}
